import { object, string } from 'yup'

export const EducationSchema = object().shape({
  id: string(),
  _id: string(),
  degree: string().required(),
  university: string().required(),
})
